'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Common.DistanceUnit', ['AVRO.Common.Configuration']).service('DistanceUnitService', require('./services/DistanceUnitService'));